import { LOGROCKET_URL } from '../settings';

export const initializeLogRocketSession = (userId: string, props?: object) => {
  if (!LOGROCKET_URL) return;

  import('logrocket').then(({ default: LogRocket }) => {
    LogRocket.init(LOGROCKET_URL);
    LogRocket.identify(userId, props ? { ...props } : {});
  });
};